import type { VfConfig } from '#types/config/components/vf'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    panel: {
      close: 'duration rounded-xs p-1 @hactive:bg-brand-2',
      header: 'subtitle-3 py-4 pl-4 pr-3 b-b b-grey-70 lg:(pl-6 pr-4)',
      wrapper: 'p-6'
    },
    modal: {
      header: 'subtitle-3'
    }
  }
} satisfies RecursivePartial<VfConfig['dialog']>
